import { Instagram, Twitter, Mail, Phone, Globe } from "lucide-react";
import { MaskLines, Reveal } from "./Motion";
import EnquiryForm from "./EnquiryForm";
import { Logo } from "./Logo";
import { CONTACT } from "../../data/content";

const Badge = () => (
  <div className="relative grid h-32 w-32 place-items-center" data-testid="responsible-drinking-badge">
    <svg viewBox="0 0 120 120" className="spin-slow absolute inset-0 h-full w-full" aria-hidden="true">
      <defs><path id="c" d="M60 60 m-48 0 a48 48 0 1 1 96 0 a48 48 0 1 1 -96 0" /></defs>
      <text className="fill-white font-mono text-[9px] uppercase tracking-[0.18em]"><textPath href="#c">Drink responsibly · Legal age only · JAI हो! ·</textPath></text>
    </svg>
    <div className="text-center"><p className="font-mono text-2xl text-white">&lt;5%</p><p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white">ABV</p></div>
  </div>
);

const Row = ({ icon: Icon, href, children, testId }) => (
  <a href={href} data-testid={testId} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer" className="group flex items-center gap-3 py-2 text-white transition-colors hover:text-mist">
    <Icon className="h-4 w-4 text-white" /><span className="border-b border-transparent group-hover:border-mist">{children}</span>
  </a>
);

export default function Footer() {
  return (
    <footer id="contact" className="relative overflow-hidden bg-forest pb-24 pt-24 text-white lg:pt-36" data-testid="site-footer">
      <div className="wrap">
        <p className="eyebrow text-white">Chapter 07 — Raise your glass</p>
        <MaskLines className="mt-6 font-display text-[15vw] font-semibold leading-[0.88] tracking-tight lg:text-[10rem]" lines={["Raise your glass", <span key="b" className="italic text-mist">with JAI <span className="font-deva not-italic">हो!</span></span>]} />

        <div className="mt-20 grid grid-cols-1 gap-14 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <Logo tone="white" className="h-7 sm:h-8" />
            <p className="mt-6 text-base text-white">Himachal <span className="font-deva">हो!</span> (earlier known as Himachal Premium Indian Cider) is a brand of {CONTACT.company}</p>
            <div className="mt-8">
              {CONTACT.emails.map((e) => <Row key={e} icon={Mail} href={`mailto:${e}`} testId={`contact-${e.split("@")[0]}`}>{e}</Row>)}
              {CONTACT.phones.map((p) => <Row key={p} icon={Phone} href={`tel:${p.replace(/\s/g, "")}`} testId={`contact-phone-${p.slice(-4)}`}>{p}</Row>)}
              <Row icon={Globe} href="https://www.himachalcider.com" testId="contact-web">{CONTACT.web}</Row>
              <Row icon={Instagram} href={CONTACT.instagram} testId="social-instagram">@himachalho</Row>
              <Row icon={Twitter} href={CONTACT.twitter} testId="social-twitter">@himachalcider</Row>
            </div>
            <div className="mt-10"><Badge /></div>
          </Reveal>
          <Reveal className="lg:col-span-7" delay={0.1}><EnquiryForm /></Reveal>
        </div>

        <div className="mt-20 flex flex-col gap-4 border-t border-white/30 pt-8 text-xs leading-relaxed text-white lg:flex-row lg:justify-between">
          <p className="max-w-3xl">Contains alcohol, &lt;5% ABV. Not for sale to persons below the legal drinking age. Please enjoy responsibly and never drink and drive. Product of India. Best served chilled. Do not consume if cloudy.</p>
          <p className="shrink-0">© {new Date().getFullYear()} {CONTACT.company} All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
